import { graphql } from "@/shared/gql";
import { EntityNotFoundError } from "@/shared/lib/errors/404-not-found-error";
import { useSuspenseQuery } from "@apollo/client";

export const FetchCurrentUser = graphql(`
  query CurrentUser($companyId: ID!) {
    currentUser(company: $companyId) {
      id
      ...AllCompanyUserProps
    }
  }
`);

type Props = {
  companyId: string;
};

export const useFetchCurrentUserQuery = ({ companyId }: Props) => {
  const result = useSuspenseQuery(FetchCurrentUser, {
    variables: { companyId },
  });

  if (result.error) {
    throw result.error;
  }

  if (!result.data?.currentUser) {
    throw new EntityNotFoundError("User");
  }

  return result.data.currentUser;
};
